import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { ACTIVE_TENANT } from '../tenant/tenants';
import { AuthModalService } from '../services/auth-modal.service';
import { AuthService } from '../services/auth.service';
import { UnifiedAccountRedirectService } from '../services/unified-account-redirect.service';

const handleUnifiedAccountAccess = (): boolean => {
  const authService = inject(AuthService);
  const authModalService = inject(AuthModalService);
  const unifiedAccountRedirect = inject(UnifiedAccountRedirectService);

  authService.refreshAuthState();

  if (authService.isAuthenticated()) {
    unifiedAccountRedirect.redirect();
    return false;
  }

  authModalService.open(null, { redirectToUnifiedAccount: true });
  return false;
};

export const unifiedAccountGuard: CanActivateFn = () => handleUnifiedAccountAccess();

export const unifiedAccountMatchGuard: CanMatchFn = () => handleUnifiedAccountAccess();

/** Login, sign-up and profile only exist for tenants with accounts; others land on home. */
export const accountsEnabledGuard: CanMatchFn = () =>
  ACTIVE_TENANT.features.accounts || inject(Router).createUrlTree(['/home']);
